<template>
    <div class="vue-modal">
        <div id="authentication-modal" @click.self="SET_SHOW_SIDE_NAV(false)" tabindex="-1" aria-hidden="true"
            class="w-full h-full flex bg-gray-800/80  overflow-hidden fixed top-0 right-0 left-0 z-20 md:inset-0">
            <aside class="w-64 bg-white h-screen flex flex-col justify-between shadow-md lg:pt-[5.5em]">
                <!-- Topo: Dados do Curso -->
                <div class="m-4 p-4 bg-secondary/5 rounded">
                    <!-- <p v-if="getTabLabel('subtitle')" -->
                    <p v-html="getTenantText('side_subtitle', '')" />
                    <p class=" mt-4 text-sm font-medium text-gray-700">{{ getTenantText('side_class', '2026 / 2027') }}
                    </p>
                    <p v-if="getProgressGeneral" class="text-right -my-1 font-bold text-xs text-gray-600">{{
                        getProgressGeneral.porcentagem }} %</p>
                    <div v-if="getProgressGeneral" class="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div :style="{ width: getProgressGeneral.porcentagem + '%' }"
                            class="bg-blue-500 h-full transition-all duration-300 ease-in-out"></div>
                    </div>
                    <p class="text-xs text-gray-400 mt-4">
                        {{ getTenantText('side_startDate', '') }}
                        <br />
                        {{ getTenantText('side_endDate', '') }}
                    </p>
                </div>
                <!-- Navegação Principal -->
                <nav class="flex-1 overflow-y-auto px-8 py-4 border-t">
                    <ul class="space-y-2 text-sm">
                        <li v-for="item in getItensNavBar" :key="item.id">
                            <router-link :to="item.url" @click="SET_SHOW_SIDE_NAV(false)"
                                class="flex items-center gap-3 rounded-md px-3 py-2 text-gray-600 hover:bg-gray-100 hover:text-black transition"
                                :class="{ 'bg-secondary/10 rounded': activeNavItem(item) }">
                                <span v-html="item.svg"></span>
                                <span>{{ getNavLabel(item) }}</span>
                            </router-link>
                        </li>
                    </ul>
                </nav>
                <!-- Rodapé: Próximas Disciplinas -->
                <div v-if="getNextSubjects && getNextSubjects.lenght" class="p-4 border-t">
                    <h3 class="my-4 text-xs font-semibold text-gray-400 uppercase mb-2">Próximas Disciplinas</h3>
                    <ul class="space-y-2 text-sm">
                        <router-link v-for="(subject, index) in getNextSubjects" :key="index"
                            :to="'/subject/' + subject.id" @click="SET_SHOW_SIDE_NAV(false)"
                            class="flex items-center gap-3 rounded-md px-3 py-2 text-gray-400 hover:bg-gray-100 hover:text-black transition cursor-pointer"
                            :class="{ 'text-gray-600': 0 === index }">
                            <div class="w-3 h-3 border rounded-full" :class="{ 'border-secondary': 0 === index }"></div>
                            <span>{{ subject.nome }}</span>
                        </router-link>
                    </ul>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    name: "SideNavComponnent",
    components: {},
    mounted() {
        this.fetchProgressGeneral();
        this.fetchNextSubjects();
    },
    methods: {
        ...mapActions(['fetchProgressGeneral', 'fetchNextSubjects']),
        ...mapMutations(['SET_SHOW_SIDE_NAV']),

        activeNavItem(item) {
            return this.$route.path === item.url;
        }
    },
    computed: {
        ...mapGetters(['getItensNavBar', 'getProgressGeneral', 'getNextSubjects', 'getNavLabel', 'getTenantText', 'getTabLabel']),
    }
}
</script>